import { Injectable } from "@angular/core"
import { APP_INJECTOR } from "app.module"
import { Constants } from "config/constants"
import { AppHttp } from "core/http"
import { WebviewLogService } from "./webview-log.service"
const ENV = Constants.ENV

@Injectable()
export class WebviewTimelogService extends WebviewLogService {

  //private _appHttp: AppHttp
  private _count: number = 1
  private _duration: number
  private _components: string[]
  private _lastSendId: number
  private _isFirst: boolean

  constructor() {
    //this._appHttp = APP_INJECTOR.get(AppHttp)
    super()
    this._components = []
    this._duration = 0
    this._isFirst = true
  }

  public bell(path: string) {
    if (!this._isFirst) return
    this._isFirst = false
    let params = { path: path }
    this.remoteSend('timelog', params)
  }

  public sendDuration(duration: number, component: string) {
    this._components.push(component)
    this._duration += duration
    this._lastSendId = window.setTimeout(() => {
      this.beginSend()
    }, 1000)
  }

  public nextScreen() {
    if (this._lastSendId) window.clearTimeout(this._lastSendId);
  }

  // private remoteSend(params) {
  //   let url = '/timelogs'
  //   let body = JSON.stringify(params)
  //   return this._appHttp.post(url, body).subscribe(resp => console.log(resp))
  // }

  private beginSend() {
    this._lastSendId = null
    let params = {
      screen: this._components[this._components.length - 1],
      duration: this._duration,
      number: this._count
    }
    this.remoteSend('timelog', params)
    this._duration = 0
    this._count++
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/pages/webview/webview-timelog.service.ts